import { requestApi } from 'api/api'
import { BASE_API_URL } from 'constants/links'
import { EmbeddedCustomerAgreement } from 'pages/EmbeddedCustomers/helpers/types'

export const getEmbeddedCustomerAgreements = (
  reference: string
): Promise<EmbeddedCustomerAgreement[]> => {
  return requestApi({
    baseUrl: BASE_API_URL,
    url: `/platform/v1/customers/${reference}/agreements`,
    method: 'GET',
  })
}
